export default {
  apiKey: "AIzaSyC-Nq6rFVfsnZqbfp25mBTB4UTcVOox5fg",
  authDomain: "jmdb-production.firebaseapp.com",
  databaseURL: "https://jmdb-production.firebaseio.com",
  projectId: "jmdb-production",
  storageBucket: "jmdb-production.appspot.com",
  messagingSenderId: "494614706393"
}
